import {  WaitlistFilterModel } from "../../models/FormDataModel"
import { GET_ALL_WAITLISTS, SELECTED_WAITLIST, SET_FILTER, RESET_FILTER, GET_WAITLIST_CLIENTS, ADD_CLIENT_WAITLIST, GET_ALL_WAITLIST_STATUSES, EDIT_CLIENT_WAITLIST, SEARCH_WAITLIST_CLIENT, REMOVE_CLIENT_WAITLIST } from "../actions/WaitlistAction"

const initialState = {
    allWaitlist:[],
    allWaitlistStatuses:[],
    waitlistClients:[],
    filter: WaitlistFilterModel,
    isFilterApplied: false,  
    selectedWaitlist: null,  
    searchValue:null
}
const WaitlistReducer = (state = initialState, action)=>{
  
    switch(action.type){  
        case GET_ALL_WAITLISTS: 
            return {...state, allWaitlist:action.allWaitlist}   
        case GET_ALL_WAITLIST_STATUSES:
            return {...state, allWaitlistStatuses:action.statuses}
        case GET_WAITLIST_CLIENTS:           
            return {...state, waitlistClients:action.waitlistClients} 
        case SET_FILTER:
            return {...state, isFilterApplied: true, filter: {...state.filter}}
        case RESET_FILTER:
            return {...state,isFilterApplied: false, filter: {...state.filter}}    
        case SELECTED_WAITLIST:
            return {...state, selectedWaitlist:action.selectedWaitlist}
        case ADD_CLIENT_WAITLIST:
            return {...state}
        case EDIT_CLIENT_WAITLIST:
            return {...state}
        case SEARCH_WAITLIST_CLIENT:
            return {...state, searchValue:action.searchValue}
        case REMOVE_CLIENT_WAITLIST:
            return {...state}
        default:
            return {...state}           
    }

}

export default WaitlistReducer;